import { Injectable } from '@angular/core';

/**
 * A service to manage background overlays, providing functionality to show and hide them,
 * and integrating with the DOM through class manipulation.
 */

@Injectable({
  providedIn: 'root'
})
export class OverlayService {
  /**
   * Adds an overlay to the body, enabling a dimmed background effect.
   * This is achieved by adding a specific CSS class to the `body` element.
   */

  public show(): void {
    this.openOverlay();
  }

  /**
   * Removes the overlay from the body, restoring the default background.
   * This is achieved by removing the specific CSS class from the `body` element.
   */
  public hide(): void {
    this.closeOverlay();
  }

  /**
   * Internal method to apply a CSS class to the `body` element,
   * creating the effect of an active overlay.
   */
  private openOverlay(): void {
    document.body.classList.add('body-overlay');
  }

  /**
   * Internal method to remove the CSS class responsible for the overlay effect
   * from the `body` element.
   */
  private closeOverlay(): void {
    if (document.body.classList.contains('body-overlay')) {
      document.body.classList.add('body-overlay-fadeout');
      setTimeout(() => {
        document.body.classList.remove('body-overlay');
        document.body.classList.remove('body-overlay-fadeout');
      }, 300)

    }
  }
}
